var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(!_vm.$fetchState.pending && !_vm.$fetchState.error && _vm.page && _vm.page.fields)?_c('ContentfulWidgetList',{attrs:{"widgets":_vm.page.fields.widgets || []}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }